import React from 'react';
import { Create, List, Datagrid, TextField,  BooleanInput, Edit,SimpleForm,DisabledInput  } from 'react-admin';
import {    TextInput, Toolbar, SaveButton, BooleanField  } from 'react-admin';

import {   EditButton } from 'react-admin';

export const DocumentTypeList = props => (
    <List {...props} bulkActionButtons={null} >
        <Datagrid  >
            <EditButton />
            <TextField source="id" />
            <TextField source="description" />
            <BooleanField source="active" />
        </Datagrid>
    </List>
);

const PostEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />  
    </Toolbar>
);

/// 
export const DocumentTypeEdit = props => (
    <Edit title={<DocumentTypeTitle />} {...props} redirect="list" >
        <SimpleForm validate={validateDocumentTypeCreation} toolbar={<PostEditToolbar />}>
           <DisabledInput source="id" />
           <TextInput source="description" />
           <BooleanInput source="active"   />
        </SimpleForm>
    </Edit>
);
///
export const DocumentTypeCreate = props => (
    <Create {...props}>
        <SimpleForm validate={validateDocumentTypeCreation} redirect="list" >
            <DisabledInput source="id" />
           <TextInput source="description" />
            <BooleanInput source="active" defaultValue={true} />
        </SimpleForm>
    </Create>
);
////
const validateDocumentTypeCreation = (values) => {
    const errors = {};
    if (!values.description) {
        errors.description = ['The description is required'];
    }
    return errors
};
///
const DocumentTypeTitle = ({ record }) => {
    return <span>Document Type: {record ? `"${record.description}"` : ''}</span>;
};
